import React from 'react';
import { NavLink } from 'react-router-dom';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import {getImageUrl, devitems, generateSlug, STORAGE_KEY } from './../Common/Helpers';
import Filtros from '../Elements/Filtros';
import withRouterData from '../Common/withRouterData';
import SearchableGrid from '../Elements/SearchableGrid';
//import $ from 'jquery';
//import 'isotope-layout'; // Isotope se adjunta a jQuery como un plugin

// La URL del archivo JSON (asumiendo que está en la carpeta 'public')
var bnrimg = require('./../../images/banner/bg-fichas.jpg');
var bgimg1 = require('./../../images/background/cross-line.png');
const JSON_URL = './data/victregimen.json';
const ITEMS_PER_LOAD = 25;
const GRID_SELECTOR = '.masonry-outer';

const $ = window.jQuery;

class JsonProjectGrid5 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [], // Inicia vacío
            filter: '*',
            data: [], // Todos los proyectos cargados de la API
            itemsToShow: ITEMS_PER_LOAD, // Inicialmente solo mostramos 8
            loading: true,
            error: null,
            scriptStatus: "Esperando inicio de carga de script..."            
        };
        this.gridRef = React.createRef();
        this.$grid = null; // Instancia de jQuery Isotope
    }

    /**
     * Ciclo de Vida: componentDidMount
     * CLAVE: Cargar datos asíncronos y luego inicializar Isotope.
     */
    componentDidMount() {
        this.loadProjects().then(() => {
            // Inicializar Isotope SOLO después de que los datos están en el DOM.
            this.$grid = $(this.gridRef.current).isotope({
                itemSelector: GRID_SELECTOR,
                layoutMode: 'masonry',
            });
            console.log("Datos cargados. Isotope inicializado con plugin de jQuery.");
        }).catch(error => {
            console.error("Error al cargar o inicializar Isotope:", error);
        });
       //this.initializeGrid();
        this.loadScript('./assets/js/custom.js');
        

    }

         loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };    

    // Método Asíncrono para cargar los datos JSON
    loadProjects = async () => {
        try {
            const response = await fetch(JSON_URL);
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            const data = await response.json();
            
            // Actualiza el estado con los datos cargados.
            // Esto dispara un render() inicial.
            this.setState({ data: data },() => {
                // 2. IMPORTANTE: Llamamos a la función de inicialización del diseño
                // después de que los datos y el DOM se han actualizado.
                this.initializeGrid(); 
            }); 

        } catch (error) {
            console.error("Fallo al cargar los proyectos desde JSON:", error);
        }
    }

    loadMore = () => {
        // 1. Actualiza el estado para mostrar más ítems
        this.setState((prevState) => ({
            // itemsToShow: prevState.itemsToShow + ITEMS_PER_LOAD 
            itemsToShow: prevState.itemsToShow + 30
        }), 
        // 2. FUNCIÓN CALLBACK: Este código se ejecuta SÓLO después de que 
        //    React ha terminado de insertar los nuevos 8 divs en el DOM.
        () => {
            // Ejecuta el refresco del plugin aquí
            this.initializeGrid(); 
            //initializeIsotopeGrid(GRID_SELECTOR); 
        });
    }      

    initializeGrid() {
        // 1. Verifica si el plugin principal (e.g., jQuery, Isotope) está cargado

/* 	window.jQuery(window).on('load', function () {

        page_loader();

    });     

	function page_loader() {
		window.jQuery('.loading-area').fadeOut(10)
	}; */

        if (window.jQuery && this.gridRef.current) {
            
            // 2. Ejecuta el comando de refresco del layout.
            // **ESTE CÓDIGO DEPENDE DEL PLUGIN QUE USES.**
            
            // Ejemplo A: Si usas Masonry
            // window.jQuery(this.gridRef.current).masonry('reloadItems'); 
            
            // Ejemplo B: Si usas Isotope

        }

        if ( window.jQuery().isotope ) {    
            
            // window.jQuery('.masonry-outer').isotope('reloadItems').isotope({ sortBy: 'original-order' });

            var $container =  window.jQuery('.masonry-outer').isotope('reloadItems').isotope({ sortBy: 'original-order' });

            $container.imagesLoaded().progress( function() {
                $container.isotope('layout');
            })            
            
            console.log("-> Layout del Grid de Proyectos ha sido recalculado.");            

         }
    } 
    
    


    /**
     * Ciclo de Vida: componentDidUpdate
     * Asegura que Isotope reaccione a los cambios (filtrado o nuevos elementos).
     */
    componentDidUpdate(prevProps, prevState) {
        // Solo continuar si la instancia de Isotope ha sido inicializada
        if (!this.$grid) return; 

        // 1. Manejar el cambio de filtro
        if (prevState.filter !== this.state.filter) {
            this.$grid.isotope({ filter: this.state.filter });
            console.log(`Filtro aplicado: ${this.state.filter}`);
        }
        
        // 2. Manejar la carga inicial (de vacío a datos) o adición de elementos
        if (prevState.items.length !== this.state.items.length) {
             // reloadItems fuerza a Isotope a re-indexar los elementos DOM que React ha insertado
             this.$grid.isotope('reloadItems'); 
             this.$grid.isotope('arrange');
             console.log(`Isotope refrescado. Total de proyectos: ${this.state.items.length}`);
        }
    }

    // ... (componentWillUnmount y otros métodos se mantienen iguales) ...
    componentWillUnmount() {
        if (this.$grid) {
            this.$grid.isotope('destroy');
            console.log("Isotope destruido (plugin jQuery).");
        }
    }
    
    // Método para añadir un proyecto de prueba (usa datos cargados como base)
/*     addProject = () => {
        const newId = Date.now(); // ID único
        const newProject = { 
            id: newId, 
            title: `Nuevo JQ ${newId}`, 
            category: (this.state.projects.length % 2 === 0 ? 'development' : 'research') 
        };
        this.setState(prevState => ({
            projects: [...prevState.projects, newProject]
        }));
    }
 */
    handleFilterChange = (newFilter) => {
        this.setState({ filter: newFilter });
    }

    handleUpdateDevItem = (newDevItemsArray) => {

        console.info("Cargamos NewArrya");
        //console.info(newDevItemsArray)
        this.setState({ data: newDevItemsArray });
        this.initializeGrid();        
        
    }
    
    destroyIsotopeGrid() {
        const isotopeInstance = window.jQuery('.masonry-outer');
            isotopeInstance.destroy();
            isotopeInstance = null;
            console.log("Isotope Grid destruido.");
    }      

    render() {

         const { data: items, loading, error, itemsToShow } = this.state;
         var texto = <p>La presente información ha sido extraída de diversas fuentes como medios de comunicación social, redes sociales, familiares de las victimas, instituciones, entre otras.</p>
         var texto2 = <p>No se detalla con exactitud la cantidad de personas fallecidas por no ser dato oficial de parte de la Dirección de Centros Penales, Instituto de Medicina Legal (IML) o Policía Nacional Civil (PNC).</p>
        //console.info(items);
        // 1. Determinar qué proyectos mostrar (Slice del array)
        const visibleItems = items.slice(0, itemsToShow);
        
        // 2. Comprobar si hay más proyectos para cargar
        const hasMoreProjects = itemsToShow < items.length;   
        

        if (error) {
            return <p style={{ color: 'red' }}>Error fatal: {error.message}</p>;
        }        
        const isLoading = items.length === 0;

        if (items.length === 0) {
           // return <h2>Cargando proyectos...</h2>;
        }
         console.info("TAm len " + items.length + isLoading);   
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title="REGISTRO DE LA MEMORIA: VÍCTIMAS DEL RÉGIMEN DE EXCEPCIÓN DE EL SALVADOR" pagename="" description={{texto ,texto2}} bgimage={bnrimg}/>
                    
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 column-grid-4 inner-page-padding">
                        <div className="container">
                            {/* Filter Nav START */}
{/*                             <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation masonry-filter clearfix">
                                    <li className="active"><NavLink to={"#"} className="btn from-top" data-filter="*" data-hover="All">All</NavLink></li>
                                    {filters.map((item, index) => (
                                        <li key={index}><NavLink to={"#"} className="btn from-top" data-filter={item.filter} >{item.label}</NavLink></li>
                                    ))}
                                </ul>
                            </div> */}
{/*                             <Filtros></Filtros>   */} 
                                <SearchableGrid data={devitems} onUpdateItem={this.handleUpdateDevItem}></SearchableGrid>                         
                            {/* Filter Nav END */}
                            {/* GALLERY CONTENT START */}
{/*                             <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled grid-5">
                                {projects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`}>
                                        <div className="sx-box image-hover-block">
                                            <div className="sx-thum-bx">
                                                <img src={item.image} alt="" />
                                            </div>
                                            <div className="sx-info  p-t20 text-white">
                                                <h4 className="sx-tilte"><NavLink to={"/project-detail1"}>{item.title}</NavLink></h4>
                                                <p className="m-b0">{item.address}</p>
                                            </div>
                                            <a className="mfp-link" href={item.image}>
                                                <i className="fa fa-arrows-alt" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                             </ul> */}
                             <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled grid-5" ref={this.gridRef} style={{ position: 'relative' }}>

                {isLoading ? (
                        <div className="loading-message grid-item">
                            <h2>Cargando proyectos...</h2>
                        </div>
                    ) : (
                        // 2. Muestra los proyectos si ya están cargados
                        visibleItems.map((item, index) => {
                                                const itemSlug = generateSlug(item.id, item.Nombre);
                                                
                                                return (
                                                        <div key={index} className={`${item.filter} ${item.filter2} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`} 
                                                            data-nombre={item.Nombre}
                                                            data-centropenal={item.centropenal}
                                                            data-departamento={item.departamento}
                                                        >
                                                            <div className="sx-box image-hover-block">
                                                                <div className="sx-thum-bx">
                                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                                </div>
                                                                <div className="sx-info  p-t20 text-white">
                                                                    <h4 className="sx-tilte"><NavLink  to={`/ficha/${itemSlug}` } state={{ projectData: item }} >{item.Nombre}</NavLink></h4>
                                                                    {/* <p className="m-b0">{item.clasifdelito}</p> */}
                                                                    <p style={{marginBottom: '1px'}}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                                    <p style={{marginBottom: '1px'}}> <b>Fecha de desceso:</b> {item.fechadeceso}</p>                                                                    
                                                                </div>
                    {/*                                             <a className="mfp-link" href={getImageUrl(item.id + "pearch.jpg")} title={item.Nombre +  '\t \n \n Fecha de deceso: ' + item.fechadeceso}>
                                                                    <i className="fa fa-arrows-alt" />
                                                                </a> */}
                                                                <a className="mfp-link" href={`#${item.id}`} title={item.Nombre +  '\t \n \n Fecha de deceso: ' + item.fechadeceso}>
                                                                    <i className="fa fa-arrows-alt" />
                                                                </a>                                            
                                                            </div>
                                                            <div 
                                                                id={item.id} 
                                                                className="mfp-hide" // Clase requerida por Magnific Popup para ocultar
                                                                style={{ background: '#f8f6f6ff', padding: '20px', maxWidth: '470px', margin: '0 auto' }}
                                                            >
                                                                <div className="sx-thum-bx">
                                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                                </div>
                                                                <h4 className="sx-title">{item.Nombre}</h4>
                                                                <p style={{marginBottom: '1px'}}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                                <p style={{marginBottom: '1px'}}> <b>Fecha de desceso:</b> {item.fechadeceso}</p>
                                                                <p style={{marginBottom: '1px'}}> <b>Motivo del deceso:</b> {item.motivodeceso}</p>                                            
                                                            </div>                                        
                                                        </div>
                                                );
                                            })
                    )}


{/*                                 {visibleItems.map((item, index) => {
                                                const itemSlug = generateSlug(item.id, item.Nombre);
                                                
                                                return (
                                                        <div key={index} className={`${item.filter} ${item.filter2} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12 m-b30`} 
                                                            data-nombre={item.Nombre}
                                                            data-centropenal={item.centropenal}
                                                            data-departamento={item.departamento}
                                                        >
                                                            <div className="sx-box image-hover-block">
                                                                <div className="sx-thum-bx">
                                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                                </div>
                                                                <div className="sx-info  p-t20 text-white">
                                                                    <h4 className="sx-tilte"><NavLink  to={`/ficha/${itemSlug}` } state={{ projectData: item }} >{item.Nombre}</NavLink></h4>
                                                                    <p style={{marginBottom: '1px'}}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                                    <p style={{marginBottom: '1px'}}> <b>Fecha de desceso:</b> {item.fechadeceso}</p>                                                                    
                                                                </div>

                                                                <a className="mfp-link" href={`#${item.id}`} title={item.Nombre +  '\t \n \n Fecha de deceso: ' + item.fechadeceso}>
                                                                    <i className="fa fa-arrows-alt" />
                                                                </a>                                            
                                                            </div>
                                                            <div 
                                                                id={item.id} 
                                                                className="mfp-hide" // Clase requerida por Magnific Popup para ocultar
                                                                style={{ background: '#f8f6f6ff', padding: '20px', maxWidth: '470px', margin: '0 auto' }}
                                                            >
                                                                <div className="sx-thum-bx">
                                                                    <img src={getImageUrl(item.id + "pearch.jpg", item.SEXO)} alt="" />
                                                                </div>
                                                                <h4 className="sx-title">{item.Nombre}</h4>
                                                                <p style={{marginBottom: '1px'}}> <b>Ciudad:</b> {item.regionresidia}, <b>Departamento:</b>  {item.departamento}</p>
                                                                <p style={{marginBottom: '1px'}}> <b>Fecha de desceso:</b> {item.fechadeceso}</p>
                                                                <p style={{marginBottom: '1px'}}> <b>Motivo del deceso:</b> {item.motivodeceso}</p>                                            
                                                            </div>                                        
                                                        </div>
                                                );
                                            })}                                 */}

                             </ul>

                            {/* Botón de Cargar Más */}
                            {hasMoreProjects && (
                                <div className="row m-t30">
                                    <div className="col-lg-12 text-center">
                                        <div className="text-center load-more-btn-outer" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                            <button onClick={this.loadMore} className="site-button-secondry btn-half"><span>Cargar más</span></button>
                                        </div>
                                    </div>
                                </div>
                            )}                             

                            {/* GALLERY CONTENT END */}

                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                </div>

                <Footer />
            </>
        );
    }
}

export default withRouterData(JsonProjectGrid5);